
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m19.82 4.17999c-.24-.23999-.6288-.23999-.8687 0l-6.9513 6.95131-6.95126-6.95131c-.23999-.23999-.62878-.23999-.86875 0s-.23999.62878 0 .86875l6.95131 6.95126-6.95131 6.9513c-.23999.2399-.23999.6287 0 .8687s.62877.24.86875 0l6.95126-6.9513 6.9513 6.9513c.2399.24.6287.24.8687 0s.24-.6288 0-.8687l-6.9513-6.9513 6.9513-6.95126c.24-.23999.24-.62878 0-.86875z","fill":"#4a3428","stroke":"#4a3428"}})])
          )
        }
      }
    